import React, { Component } from 'react';
import { connect } from 'react-redux';
import { _LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import { recommendReviewActions } from '../../../store/modules/recommend/review';
import {
  RECOMMEND_REVIEW_LIST_SEARCH_DATA_MODEL,
  RECOMMEND_REVIEW_LIST_SEARCH_OPTION_MODEL,
} from '../../../store/modules/recommend/review/models';
import RecommendReviewListWrap from '../../../views/recommend/review/list/RecommendReviewListWrap';

class RecommendReviewListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    const { setData } = this.props;

    this.getList({
      /**
       *  검색 옵션
       */
      searchOption: RECOMMEND_REVIEW_LIST_SEARCH_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });

    /**
     * 검색 박스 초기화
     */
    setData({
      path: ['recommendReviewList', 'searchData'],
      value: RECOMMEND_REVIEW_LIST_SEARCH_DATA_MODEL,
    });
  };

  /**
   * 리스트 불러오기
   */
  getList = async (data) => {
    const { getRecommendReviewList, recommendReviewList } = this.props;
    const { searchOption, sortOption, pagination } = recommendReviewList;

    getRecommendReviewList({
      searchOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  render() {
    const { recommendReviewList, setData } = this.props;

    return (
      <RecommendReviewListWrap recommendReviewList={recommendReviewList} setData={setData} getList={this.getList} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    recommendReviewList: state.recommendReview.recommendReviewList,
  };
};

const mapDispatchToProps = {
  setData: recommendReviewActions.setData,
  getRecommendReviewList: recommendReviewActions.getRecommendReviewList,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecommendReviewListContainer);
